import React, { Component as C } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import styles from "./widget.less"
import jss from "jss"
import withSkin from "@cirrus/legacy/app-common/alt/framework/withSkin.jsx"
import v from "@cirrus/legacy/app-components/app/styles/colors/colors-default.less"
import { toJss, darken } from "@cirrus/legacy/app-common/alt/framework/skin/skinUtils.es6"

class Widget extends C {
  static displayName = "Widget_Eas"

  static propTypes = {
    widgetClassName: PropTypes.string,
    blockClassName: PropTypes.string,
    titleClassName: PropTypes.string,
    contentClassName: PropTypes.string,
    value: PropTypes.string,
  }

  render() {
    let widgetClassName = classnames(this.props.widgetClassName, styles.widget)
    let blockClassName = classnames(styles.block, "infobox_block", this.props.blockClassName)
    let titleClassName = classnames(this.props.titleClassName, styles.title)
    let contentClassName = classnames(this.props.contentClassName, styles.content)

    return (
      <div className={widgetClassName} data-qa={this.props["data-qa"]}>
        <div className={blockClassName}>
          <div className={titleClassName}>{this.props.children}</div>
          <div className={contentClassName}>{this.props.value}</div>
        </div>
      </div>
    )
  }
}

export default Widget
